import {getMethod, postMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/manualExchangeRates', request)
}

async function post(request) {
    return await postMethod('/api/manualExchangeRates', request)
}

export {get, post}
